import type { AncFormField, PnFormTemplate } from '@type/antenatal.type'

const motherFields: AncFormField[] = [
  { key: 'blood_pressure', label: 'Blood pressure', type: 'text', unit: 'mmHg', section: 'Mother', required: true },
  { key: 'temperature_c', label: 'Temperature', type: 'number', unit: '°C', section: 'Mother' },
  {
    key: 'lochia',
    label: 'Lochia',
    type: 'select',
    options: ['Normal', 'Heavy', 'Foul smelling', 'Absent', 'Not assessed'],
    section: 'Mother'
  },
  {
    key: 'breasts',
    label: 'Breasts',
    type: 'select',
    options: ['Normal', 'Engorged', 'Mastitis suspected', 'Not assessed'],
    section: 'Mother'
  },
  {
    key: 'uterus_involuted',
    label: 'Uterus involuted',
    type: 'boolean',
    section: 'Mother'
  },
  { key: 'hemoglobin', label: 'Hemoglobin', type: 'number', unit: 'g/dL', section: 'Mother' },
  { key: 'notes', label: 'Mother notes', type: 'textarea', section: 'Mother' }
]

const newbornFields: AncFormField[] = [
  {
    key: 'feeding',
    label: 'Feeding',
    type: 'select',
    options: ['Exclusive breastfeeding', 'Mixed', 'Formula', 'Not assessed'],
    section: 'Newborn',
    required: true
  },
  { key: 'weight_kg', label: 'Weight', type: 'number', unit: 'kg', section: 'Newborn' },
  { key: 'temperature_c', label: 'Temperature', type: 'number', unit: '°C', section: 'Newborn' },
  {
    key: 'jaundice',
    label: 'Jaundice',
    type: 'select',
    options: ['None', 'Mild', 'Moderate', 'Severe', 'Not assessed'],
    section: 'Newborn'
  },
  {
    key: 'cord',
    label: 'Cord',
    type: 'select',
    options: ['Clean / dry', 'Infected', 'Bleeding', 'Not assessed'],
    section: 'Newborn'
  },
  { key: 'bcg_given', label: 'BCG given', type: 'boolean', section: 'Newborn' },
  { key: 'opv0_given', label: 'OPV0 given', type: 'boolean', section: 'Newborn' },
  { key: 'notes', label: 'Newborn notes', type: 'textarea', section: 'Newborn' }
]

/** Builtin PN template — swap for API `pnFormTemplate` later without changing the workspace. */
export const DEFAULT_PN_TEMPLATE: PnFormTemplate = {
  id: 'builtin-pn',
  type: 'pn_form_template',
  attributes: {
    name: 'Default postnatal',
    is_default: true,
    mother_fields: motherFields,
    newborn_fields: newbornFields
  }
}
